import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=60f8b9e4&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=60f8b9e4&prod&lang=scss&scoped=true&"
import style1 from "./Preview.vue?vue&type=style&index=1&id=60f8b9e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8b9e4",
  null
  
)

export default component.exports